import { getStudioLogo } from '@/hooks/useStudioLogo';
import { cn } from '@/lib/utils';

export const StudioLogo = ({
  code,
  className,
}: {
  code: string;
  className?: string;
}) => {
  const { src, mono } = getStudioLogo(code);
  return (
    <img
      src={src}
      alt=""
      className={cn(
        'shrink-0 object-contain',
        mono && 'brightness-0 dark:invert',
        className,
      )}
    />
  );
};
